var timerscrolled;
var lastVisibleElementId = null;
var visibleElementId = null;

$(document).ready(function () {
  $(".btnaddtocart-class").click(function (e) {
    e.preventDefault();
    console.log('xxxx');
    $(
      "#ProductInfo-template--23447107207485__main .product-form button .js-go-cart-add-to-cart"
    ).trigger("click");
  });
  
  $('#Slider-Thumbnails-template--23447107207485__main li button').on('click', function() {

    $('.ohmvideobg').each(function() {
        this.play();
    });
    
  });
  
  $('.anchorbtn').click(function(e) {
    e.preventDefault();
    
    var target = $('.ohm-two-column-dynamic-content').offset().top;
    var initialSpeed = 0.8;
    
    $('html, body').animate({
        scrollTop: target
    }, {
        duration: 1000, // 1 second total duration
        easing: 'swing', // Built-in easing
        step: function(now, fx) {
            var progress = now / target;  // Calculate progress
            var easeOutProgress = 1 - Math.pow(1 - progress, 3); // Cubic ease-out

            // Adjust scroll position for fast start and slow finish
            $('html, body').scrollTop(target * (initialSpeed * progress + (1 - initialSpeed) * easeOutProgress));
        }
    });
  });
  
  // Mobile menu CSS

  $('#mobilemenu-about').click(function(e) {
    e.preventDefault();

    $('.megamenu_ohm').slideToggle(500);
    var toggleIconText = $(this).find(".toggleicon-mobile").text();
    if (toggleIconText === "+") {
        $(this).find(".toggleicon-mobile").text("-");
    } else {
        $(this).find(".toggleicon-mobile").text("+");
    }
  });
  
  // End mobile menu CSS
  
  

  



  
  // OHM Video Slider component

  $('.section-template--23127923097917__ohm_video_slider_9z3eUk-slider').owlCarousel({
    items: 1,
    nav: true,
    dots: false,
    loop: true,
    responsive : {
      0 : {
        animateOut: 'slideOutUp',
        animateIn: 'slideInUp',
        items: 1,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        // margin: 0,
        // stagePadding: 50,
        // center: true,
      },
      600: {
        margin: 54,
        stagePadding: 160,
      },
      1780 : {
        stagePadding: 0,
      },
    },
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 40 39" fill="none"><path d="M36.3292 19.6831H3.37082M3.37082 19.6831L19.85 36.1623M3.37082 19.6831L19.85 3.20398" stroke="#1E1E1E" stroke-width="5.65" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 39 40" fill="none"><path d="M3.07068 19.8499H36.029M36.029 19.8499L19.5498 3.37073M36.029 19.8499L19.5498 36.3291" stroke="#1E1E1E" stroke-width="5.65" stroke-linecap="round" stroke-linejoin="round"/></svg>'  
    ],
  });

  
  // The Jewel in the Crown JS


  // $(window).on('scroll resize', function() {
  //     $('.shopify-section').each(function() {
  //         var element = $(this);
  //         var elementTop = element.offset().top;
  //         var elementBottom = elementTop + element.outerHeight();
          
  //         var viewportTop = $(window).scrollTop();
  //         var viewportBottom = viewportTop + $(window).height();
  
  //         if (elementBottom > viewportTop && elementTop < viewportBottom) {
  //             // Element is visible
  //             console.log(element.attr('id') + ' is visible');
  //         } else {
  //             // Element is not visible
  //             console.log(element.attr('id') + ' is not visible');
  //         }
  //     });
  // });
  
  $('.ohm-slider-fullbanner-carousel-absolute').owlCarousel({
    items: 1,
    nav: false,
    dots: false,
    mouseDrag: false,
    touchDrag: false,
    animateOut: 'fadeOutToBlack',
    animateIn: 'fadeInFromBlack',
  });
  
  $('.ohm-slider-fullbanner-carousel').owlCarousel({
    items: 1,
    nav: false,
    dots: false,
    mouseDrag: false,
    touchDrag: false,
    
    // animateOut: 'fadeOutToBlack',
    // animateIn: 'fadeInFromBlack',
    
    // onInitialized: function() {
    //   $('.ohm-slider-fullbanner-carousel .owl-item').each(function() {
    //     if (!$(this).find('.ohm-pc2').length) {
    //       $(this).find('.osfb-toggle').addClass('collapse');
    //     }
    //   });
    // }
  });

  $('.osfb-toggle').click(function() {
    $(this).toggleClass('collapse');
  });
  
  $('.ohm-slider-fullbanner-carousel .osfb-arrow-left').click(function() {
    $('.ohm-slider-fullbanner-carousel .owl-item .ohm-slider-buttons > span').removeClass('osfb-opac');
    if ($('.ohm-slider-fullbanner-carousel .owl-item:first-of-type').first().hasClass('active')) {
      $('.ohm-slider-fullbanner-carousel .owl-item:first-of-type .osfb-arrow-left').addClass('osfb-opac');
    }
    $('.ohm-slider-fullbanner-carousel').trigger('prev.owl.carousel', [300]);
  });

  $('.ohm-slider-fullbanner-carousel .osfb-arrow-right').click(function() {
    $('.ohm-slider-fullbanner-carousel .owl-item .ohm-slider-buttons > span').removeClass('osfb-opac');
    if ($('.ohm-slider-fullbanner-carousel .owl-item').last().hasClass('active')) {
      $('.ohm-slider-fullbanner-carousel .owl-item:last-of-type .osfb-arrow-right').addClass('osfb-opac');
    }
    $('.ohm-slider-fullbanner-carousel').trigger('next.owl.carousel', [300]);
  });
  
  // new header menu script

  $('.watcheswrapper').click(function() {
    $('.watches-menu-ohm-mobile').slideToggle(500);
    var toggleIconText = $(this).find(".toggleicon").text();
    if (toggleIconText === "+") {
        $(this).find(".toggleicon").text("-");
    } else {
        $(this).find(".toggleicon").text("+");
    }
  });

  var owlmenu = $(".watches-menu-ohm-mobile .watches-megamenu-ohm-wrapper-mobile");

  function menuMobileSliderProducts() {
    if ($(window).width() <= 990) {
      owlmenu.trigger('destroy.owl.carousel');
      owlmenu.addClass('owl-carousel owl-theme').owlCarousel({
          dots: true,
          // nav: true,
          margin: 8,
          items: 2,
          slideBy: 2,
          stagePadding: 33,
          slideTransition: 'ease-in-out',
          onTranslate: removeStagePaddingAtLastItem,
      });
    } else {
      var owlm = owlmenu;
      owlm.trigger('destroy.owl.carousel');
      owlm.removeClass('owl-carousel owl-theme');
    }
  }

  function removeStagePaddingAtLastItem(event) {
    var items = event.item.count;
    var item = event.item.index + event.page.size;

    if (item >= items) {
      owlmenu.find('.owl-stage').addClass('no-paddingright');
    } else {
      owlmenu.find('.owl-stage').removeClass('no-paddingright');
    }
  }

  menuMobileSliderProducts();

  $(window).resize(function() {
      menuMobileSliderProducts();
  });
  

  
  // new all-watches collections JS

  $('.ohmslider-buttons .slider-button--prev').click(function(e) {
    e.preventDefault();
    var container = $(this).closest('.slider-mobile-gutter').find('ul.slider');
    var items = container.find('.slider__slide');
        
    if (parseInt(container.attr('pos')) > 0) {
      container.attr('pos', parseInt(container.attr('pos')) - (items.width() * 2));
      container.attr('click', parseInt(container.attr('click')) - 1);
      
      if (parseInt(container.attr('pos')) <= 0 && parseInt(container.attr('click')) == 2) {
        container.attr('pos', items.width());
      } else if (parseInt(container.attr('pos')) <= 0) {
        container.attr('pos', 0);
      }

      container.animate({
        scrollLeft: parseInt(container.attr('pos'))
      }, 500);
    } else {
      container.animate({
        scrollLeft: 0
      }, 500, function() {
        container.attr('pos', 0);
        container.attr('click', 1);
      });
    }
  });
  
  $('.ohmslider-buttons .slider-button--next').click(function(e) {
    e.preventDefault();
    var container = $(this).closest('.slider-mobile-gutter').find('ul.slider');
    var items = container.find('.slider__slide');

    if (parseInt(container.attr('click')) < items.length) {
      if (container.attr('pos') == 0) {
        container.attr('pos', items.width());
      }

      container.animate({
        scrollLeft: parseInt(container.attr('pos'))
      }, 500, function() {
        container.attr('pos', items.width() * parseInt(container.attr('click')));
      });
    } else {
      container.animate({
        scrollLeft: 0
      }, 500, function() {
        container.attr('pos', 0);
        container.attr('click', 1);
      });
    }
    container.attr('click', parseInt(container.attr('click')) + 1);
  });


  
  $('#shopify-section-template--22830550778173__multicolumn_ohm_slider_Qx7Ldq .controlslick-wrapper .btn-prevslick').click(function(e) {
    e.preventDefault();
    var container = $(this).closest('.column-ohm').find('.slick-container');
    var items = container.find('.slider__slide');
        
    if (parseInt(container.attr('pos')) > 0) {
      container.attr('pos', parseInt(container.attr('pos')) - (items.width() * 2));
      container.attr('click', parseInt(container.attr('click')) - 1);
      
      if (parseInt(container.attr('pos')) <= 0 && parseInt(container.attr('click')) == 2) {
        container.attr('pos', items.width());
      } else if (parseInt(container.attr('pos')) <= 0) {
        container.attr('pos', 0);
      }

      container.animate({
        scrollLeft: parseInt(container.attr('pos'))
      }, 500);
    } else {
      container.animate({
        scrollLeft: 0
      }, 500, function() {
        container.attr('pos', 0);
        container.attr('click', 1);
      });
    }
  });

  $('#shopify-section-template--22830550778173__multicolumn_ohm_slider_Qx7Ldq .controlslick-wrapper .btn-nextslick').click(function(e) {
    e.preventDefault();
    var container = $(this).closest('.column-ohm').find('.slick-container');
    var items = container.find('.slider__slide');

    if (parseInt(container.attr('click')) < items.length) {
      if (container.attr('pos') == 0) {
        container.attr('pos', items.width());
      }

      container.animate({
        scrollLeft: parseInt(container.attr('pos'))
      }, 500, function() {
        container.attr('pos', items.width() * parseInt(container.attr('click')));
      });
    } else {
      container.animate({
        scrollLeft: 0
      }, 500, function() {
        container.attr('pos', 0);
        container.attr('click', 1);
      });
    }
    container.attr('click', parseInt(container.attr('click')) + 1);
  });
 
  
  // end all-watches 

  // start all straps

  function doSliderProducts() {
      if ($(window).width() <= 450) {
          $('.custom-product-ajax-add-to-cart-section').addClass('owl-carousel owl-theme').owlCarousel({
              dots: false,
              nav: false,
              margin: 30,
              items: 1,
              loop: true
          });
      } else {
          var owl = $('.custom-product-ajax-add-to-cart-section');
          owl.trigger('destroy.owl.carousel');
          owl.removeClass('owl-carousel owl-theme');
      }
  }

  doSliderProducts();

  $(window).resize(function() {
      doSliderProducts();
  });

  $('.pcd-btn-left').click(function() {
      $(this).closest('.right-column').find('.custom-product-ajax-add-to-cart-section').trigger('prev.owl.carousel');
  });

  $('.pcd-btn-right').click(function() {
      $(this).closest('.right-column').find('.custom-product-ajax-add-to-cart-section').trigger('next.owl.carousel');
  });
  
  $('.product-custom-display-section').closest('#MainContent').addClass('bg-cream-color');
  
  $('.pcd-variants-wrapper .pcd-variant').click(function() {
    $(this).closest('.custom-product-ajax-add-to-cart-section > .product').hide();
    $(this).closest('.custom-product-ajax-add-to-cart-section').find('#product-'+ $(this).data('id') +'-div').show();
  });

  $('.pcd-variant-radio').change(function() {
    if ($(this).is(':checked')) {
      $(this).closest('div.product').find('.pcd-append-text').remove();
      $(this).closest('div.product').find('.pcd-top h2').append(
        $('<span class="pcd-append-text">').text($(this).next('label').find('span').text())
      );
      $(this).closest('.quick-add').find('.quick-add__submit').removeAttr('disabled');
    }
  });
  
  // end all straps
  
  // skywod diver JS codes
  $("#skywodbtnaddtocart").on('click', function (e) {
    e.preventDefault();
    $(
      "#MainProduct-template--22717552591165__main .product-form button .js-go-cart-add-to-cart"
    ).trigger("click");
  });

  var documentHeight = $(document).height();
  var twentyPercentHeight = documentHeight * 0.10;
  $(window).scroll(function() {
      var scrollPosition = $(window).scrollTop();
      
      if (scrollPosition >= twentyPercentHeight) {
        $("#shopify-section-template--22717552591165__image_with_text_LTbqrm").fadeIn();
        $(window).off("scroll");
      }
  });

  $("#shopify-section-template--22717552591165__image_with_text_LTbqrm").click(function(event) {
    $(this).fadeOut();    
  });

  $(document).on('keydown', function(event) {
      if (event.key === 'Escape' && $("#shopify-section-template--22717552591165__image_with_text_LTbqrm").length) {
          $("#shopify-section-template--22717552591165__image_with_text_LTbqrm").fadeOut();
      }
  });

  $("#shopify-section-template--22717552591165__image_with_text_LTbqrm .image-with-text__grid").click(function(event) {
      event.stopPropagation();
  });

  $("#shopify-section-template--22717552591165__multicolumn_rYAx6i div.media > img," +
    "#Slide-template--22717552591165__multicolumn_CCQi4h-2 img," +
    "#Slide-template--22717552591165__multicolumn_ewYbNt-1 img," +
    "#Slide-template--22717552591165__multicolumn_ewYbNt-2 img"
   ).removeAttr("sizes");

  // end skywod
  
  // click event:
  $("#ProductInfo-template--22443227513149__main fieldset.swatch-pre-order > input").change(function() {
    var selectedvariant = $(this).val();
    var btncart = $("#product-form-template--22443227513149__main .js-go-cart-add-to-cart");
    $("#product-form-template--22443227513149__main button").css('opacity', 0.2);
    btncart.css('opacity', 0);
    setTimeout(function() {
      var btxt = $("span[data-variant='"+ selectedvariant +"']").text().trim();
      btncart.css('opacity', 1);
      $("#product-form-template--22443227513149__main button").css('opacity', 1);
      btncart.text(btxt);
    },1000);
  });
  
  // end click event
  
  // product4pages JS
  $("#widgetppage-wrapper>div>div").click(function () {
    $(this).unbind("mouseenter mouseleave");
    $("#widgetppage-wrapper a").removeClass("mobhover");
    $(this).find("a").addClass("mobhover");
  });

  $(
    "#shopify-section-template--22549599551805__image_with_text_VrzrQ3 .image-with-text__media"
  ).append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/sc1_51cc275e-df01-4ba1-b17a-c81b9473f5e5.jpg?v=1714840118">'
    ).addClass("imginsertedscroll")
  );

  $(
    "#shopify-section-template--22549599650109__image_with_text_VrzrQ3 .image-with-text__media"
  ).append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/sc2.jpg?v=1714841157">'
    ).addClass("imginsertedscroll")
  );

  $(
    "#shopify-section-template--22549599584573__image_with_text_VrzrQ3 .image-with-text__media"
  ).append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/sc3.jpg?v=1714841582">'
    ).addClass("imginsertedscroll")
  );

  $(
    "#shopify-section-template--22549599584573__image_with_text_VrzrQ3 .image-with-text__media"
  ).append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/sc4.jpg?v=1714841952">'
    ).addClass("imginsertedscroll")
  );

  $("#bathurst2025btnaddtocart").click(function (e) {
    e.preventDefault();
    $(
      "#MainProduct-template--23969849901373__main .product-form button .js-go-cart-add-to-cart"
    ).trigger("click");
  });
  
  $("#urlururedbtnaddtocart").click(function (e) {
    e.preventDefault();
    $(
      "#MainProduct-template--22549599551805__main .product-form button .js-go-cart-add-to-cart"
    ).trigger("click");
  });

  $("#pinkbreakbtnaddtocart").click(function (e) {
    e.preventDefault();
    $(
      "#MainProduct-template--22549599617341__main .product-form button .js-go-cart-add-to-cart"
    ).trigger("click");
  });

  $("#operanightbtnaddtocart").click(function (e) {
    e.preventDefault();
    $(
      "#MainProduct-template--22549599650109__main .product-form button .js-go-cart-add-to-cart"
    ).trigger("click");
  });

  $("#gbrbluebtnaddtocart").click(function (e) {
    e.preventDefault();
    $(
      "#MainProduct-template--22549599584573__main button .js-go-cart-add-to-cart"
    ).trigger("click");
  });

  $(
    "#GalleryThumbnails-template--22717552591165__main img," +
    "#shopify-section-template--22549599551805__image_with_text_QrM7PC img," +
    "#shopify-section-template--22549599650109__image_with_text_QrM7PC img," +
    "#shopify-section-template--22549599617341__image_with_text_QrM7PC img," +
    "#shopify-section-template--22549599584573__image_with_text_QrM7PC img"
  ).removeAttr("sizes");

  var currentUrl = window.location.href;
  var lastSegment = currentUrl.substring(currentUrl.lastIndexOf("/") + 1);
  $(".ppage-" + lastSegment).addClass("biggerthan");

  // set cookie for page color set
  var ohmcolors = {
    uluru_red: "#ed904a",
    opera_night: "#0a0a0b",
    pink_break: "#bdacaf",
    blue_barrier: "#37b8d9",
  };
  $("#widgetppage-wrapper a").click(function (e) {
    e.preventDefault();
    var ohmurl = $(this);

    $(
      "#shopify-section-template--22549599551805__main," +
        "#shopify-section-template--22549599551805__rich_text_hGKEiP," +
        "#shopify-section-template--22549599551805__image_with_text_VrzrQ3," +
        "#shopify-section-template--22549599551805__multicolumn_DEt7Kd," +
        "#shopify-section-template--22549599551805__image_with_text_DLVEBB," +
        "#shopify-section-template--22549599551805__image_with_text_QrM7PC," +
        "#shopify-section-template--22549599551805__image_banner_kANrUN," +
        "#shopify-section-template--22549599650109__main," +
        "#shopify-section-template--22549599650109__rich_text_hGKEiP," +
        "#shopify-section-template--22549599650109__image_with_text_VrzrQ3," +
        "#shopify-section-template--22549599650109__multicolumn_DEt7Kd," +
        "#shopify-section-template--22549599650109__image_with_text_DLVEBB," +
        "#shopify-section-template--22549599650109__image_with_text_QrM7PC," +
        "#shopify-section-template--22549599650109__image_banner_kANrUN," +
        "#shopify-section-template--22549599617341__main," +
        "#shopify-section-template--22549599617341__rich_text_hGKEiP," +
        "#shopify-section-template--22549599617341__image_with_text_VrzrQ3," +
        "#shopify-section-template--22549599617341__multicolumn_DEt7Kd," +
        "#shopify-section-template--22549599617341__image_with_text_QrM7PC," +
        "#shopify-section-template--22549599617341__image_with_text_DLVEBB," +
        "#shopify-section-template--22549599617341__parallax_banner_UbhR3F," +
        "#shopify-section-template--22549599617341__image_banner_kANrUN," +
        "#shopify-section-template--22549599584573__main," +
        "#shopify-section-template--22549599584573__rich_text_hGKEiP," +
        "#shopify-section-template--22549599584573__image_with_text_VrzrQ3," +
        "#shopify-section-template--22549599584573__multicolumn_DEt7Kd," +
        "#shopify-section-template--22549599584573__image_with_text_DLVEBB," +
        "#shopify-section-template--22549599584573__image_with_text_QrM7PC," +
        "#shopify-section-template--22549599584573__image_banner_kANrUN"
    ).css("background-color", ohmcolors[ohmurl.data("attrib")]);
    setTimeout(function () {
      window.location.href = ohmurl.attr("href");
    }, 1000);
  });
  // end cookie

  $(
    "#Slider-Gallery-template--22549599551805__main, #Slide-template--22549599519037__multicolumn_Vha8tj-2 .multicolumn-card__image-wrapper"
  ).append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/Gold_Medal.png?v=1714443633">'
    ).addClass("imginsertedcarou")
  );

  $("#Slide-template--22549599519037__multicolumn_VGnbcz-1 div.media").append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/1_99c57a4b-d015-47b5-942f-79346f5ff82b.png">'
    ).addClass("imginsertedhover")
  );

  $("#Slide-template--22549599519037__multicolumn_VGnbcz-2 div.media").append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/2_8bded474-8bbd-4d6f-bc01-38498f40caa8.png">'
    ).addClass("imginsertedhover")
  );

  $("#Slide-template--22549599519037__multicolumn_VGnbcz-3 div.media").append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/3_3a3fd13a-5a31-4651-9c39-441d07174d6c.png">'
    ).addClass("imginsertedhover")
  );

  $("#Slide-template--22549599519037__multicolumn_VGnbcz-4 div.media").append(
    $(
      '<img src="https://www.bausele.com/cdn/shop/files/4_ade9a9b3-a57a-48da-9c2b-3301688dd4f1.png">'
    ).addClass("imginsertedhover")
  );
  // end product4pages

  // kimberley page js

  $(".wd2colcustom img").hover(
    function () {
      $(this).closest(".displayonhover").css("opacity", 1);
    },
    function () {
      $(this).closest(".displayonhover").css("opacity", 0);
    }
  );

  $(".btnmovenext").prependTo(
    "#MainProduct-template--22309357748541__main .product-form__buttons"
  );

  // end kimberley js

  // Sold out tag in https://www.bausele.com/products/bausele-x-seconde-seconde-perspective
  $("#MainProduct-template--21980132835645__main .product__media").append(
    $('<div class="bathurstsoldout">').html($("<span>").text("Sold out"))
  );

  $("#shopify-section-template--22099496632637__main .product__media").append(
    $('<div class="bathurstsoldout">').html($("<span>").text("Sold out"))
  );

  $(
    "#Slider-Thumbnails-template--22089385738557__main > li, #Slider-Thumbnails-template--21980132835645__main > li,#Slider-Thumbnails-template--21468088697149__main > li,#Slider-Thumbnails-template--21468075295037__main > li, #Slider-Thumbnails-template--21468094890301__main > li, #Slider-Thumbnails-template--21468094857533__main> li"
  ).each(function () {
    $(this).find("img").removeAttr("sizes");
  });

  $("#GalleryViewer-template--21980132835645__main").append(
    $("#productimage-arrow")
  );

  var selected_pos = [0, 14];
  $("#Slider-Gallery-template--21980132835645__main > li").each(function (i) {
    $(this)
      .find(".product__media")
      .append(
        $('<img class="productimage-twist">').attr(
          "src",
          "https://www.bausele.com/cdn/shop/files/p-twist.png?v=1706381492"
        )
      );
    if (selected_pos.includes(i)) {
      $(this)
        .find(".product__media")
        .append(
          $('<img class="productimage-arrow">').attr(
            "src",
            "https://www.bausele.com/cdn/shop/files/p-arrow1.png?v=1706380393"
          )
        );
    }
  });

  var lastScrollTop = 0;
  $(window).scroll(function (e) {
    e.preventDefault();
    sst = $(this).scrollTop();

    if (
      $("#shopify-section-template--22089385738557__image_with_text_ecdxhG")
        .length &&
      $(
        "#shopify-section-template--22089385738557__image_with_text_ecdxhG"
      ).isInViewport()
    ) {
      var sstpos = "2px";
      if (sst < lastScrollTop) {
        if (sst < 1) {
          sstpos = 0;
        }
        $(
          "#shopify-section-template--22089385738557__image_with_text_ecdxhG .image-with-text__media img"
        ).css("top", "-=" + sstpos);
      } else {
        $(
          "#shopify-section-template--22089385738557__image_with_text_ecdxhG .image-with-text__media img"
        ).css("top", "+=" + sstpos);
      }
    }
    lastScrollTop = sst;

    // scroll 4pagesproduct

    if (sst >= 300) {
      if ($(window).width() <= 749) {
        $("#widgetppage-wrapper").css("top", "-80px");
      } else {
        $("#widgetppage-wrapper").css("top", "-50px");
      }
    } else {
      $("#widgetppage-wrapper").css("top", "0");
    }

    if (
      $(
        "#shopify-section-template--22549599551805__image_with_text_VrzrQ3," +
          "#shopify-section-template--22549599650109__image_with_text_VrzrQ3," +
          "#shopify-section-template--22549599617341__image_with_text_VrzrQ3," +
          "#shopify-section-template--22549599584573__image_with_text_VrzrQ3"
      ).length &&
      $(
        "#shopify-section-template--22549599551805__image_with_text_VrzrQ3," +
          "#shopify-section-template--22549599650109__image_with_text_VrzrQ3," +
          "#shopify-section-template--22549599617341__image_with_text_VrzrQ3," +
          "#shopify-section-template--22549599584573__image_with_text_VrzrQ3"
      ).isInViewportss()
    ) {
      $(".imginsertedscroll").css("opacity", 0);
    } else {
      $(".imginsertedscroll").css("opacity", 1);
    }

    // scrolled

    clearTimeout(timerscrolled);
    timerscrolled = setTimeout(checkVisibleElement, 100);
  });
});

function checkVisibleElement() {
  var windowHeight = $(window).height();
  var scrollTop = $(window).scrollTop();
  var scrollBottom = scrollTop + windowHeight;

  $(".shopify-section").each(function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    if (
      (elementTop >= scrollTop && elementTop <= scrollBottom) ||
      (elementBottom >= scrollTop && elementBottom <= scrollBottom) ||
      (elementTop <= scrollTop && elementBottom >= scrollBottom)
    ) {
      visibleElementId = this.id;
      return false; // Exit the loop early once a visible element is found
    }
  });

  if (visibleElementId && visibleElementId !== lastVisibleElementId) {
    lastVisibleElementId = visibleElementId;
    var replacedString = visibleElementId.replace(/\d+/g, "x");
    // console.log("Visible Element ID:", visibleElementId);
    // console.log("replacedString ID:", replacedString);
  }
}

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop() - 400;
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.isInViewportss = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop() - 550;
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};
